import { createBlueprint as e } from "@made-people/blueprint";
const r = e({
  slots: {
    base: "grid-rows-[max-content_max-content_max-content_1fr_max-content] grid-cols-[auto_1fr_max-content] grid w-[420px] mb-6 items-center [&>svg]:stroke-black",
    name: "col-start-2 col-end-3 row-start-1 row-end-2 flex mb-2 text-label-sm text-text-body",
    metaData: "col-start-2 col-end-3 row-start-3 row-end-4 text-label-sm mb-1 line-clamp-3 lg:line-clamp-2 text-text-less-emphasis-2 flex flex-col gap-2 mt-2",
    image: "w-full object-cover bg-neutral-100 h-full rounded-[8px]",
    imageWrapper: "col-start-1 col-end-2 row-span-4 flex relative aspect-product-image mr-4 rounded-[8px] bg-neutral-100 h-[118px] justify-center items-center",
    priceWrapper: "col-start-2 col-end-3 row-start-2 row-end-3 flex flex-col mb-1 justify-end text-label-sm uppercase font-secondary",
    price: "",
    oldPrice: "line-through",
    // Display quantity
    quantityValue: "flex row-start-4 row-end-5 col-start-3 text-label-sm w-fit self-end bg-neutral-100 rounded-lg px-2 py-1",
    // Item Dimensions
    itemDimensionsWrapper: "col-start-2 col-end-3 row-start-4 flex",
    itemDimensionsLabel: "text-body-sm mr-4",
    itemDimensionsValue: "text-body-sm",
    // Quantity picker
    quantityPickerWrapper: "row-start-4 row-end-5 col-start-2 col-end-3 flex gap-4 items-center text-label-sm self-end",
    quantityPickerAdd: "w-6 h-6 flex justify-center items-center [&>svg]:fill-text-body [&>svg]:hover:fill-text-body [&>svg]:hover:cursor-pointer disabled:[&>svg]:fill-neutral-100 [&>svg]:w-2 [&>svg]:h-2",
    quantityPickerRemove: "w-6 h-6 flex justify-center items-center [&>svg]:disabled:fill-neutral-200 [&>svg]:w-2 [&>svg]:h-2 [&>svg]:fill-text-body [&>svg]:hover:fill-text-body [&>svg]:hover:cursor-pointer",
    quantityPickerValue: "",
    removeButton: ""
  },
  variants: {}
}), l = e({
  slots: {
    base: "grid-rows-[max-content_max-content_max-content_1fr_max-content] grid-cols-[auto_1fr_max-content] grid w-[420px] mb-3 last:mb-0 items-center [&>svg]:stroke-black w-full",
    name: "col-start-2 col-end-3 row-start-1 row-end-2 flex mb-1 text-label-sm text-text-body",
    metaDataWrapper: "col-start-2 col-end-3 row-start-3 row-end-4 text-label-sm mb-1 text-text-less-emphasis-2 flex flex-col gap-2 mt-2",
    image: "w-full object-contain h-full",
    imageWrapper: "col-start-1 col-end-2 row-span-4 flex relative aspect-product-image mr-4 rounded-lg bg-[#F5F5F5] h-[132px] justify-center items-center overflow-hidden h-32",
    priceWrapper: "col-start-2 col-end-3 row-start-2 row-end-3 flex flex-col mb-1 justify-end text-label-sm uppercase font-secondary",
    price: "",
    oldPrice: "line-through",
    customInfoComponentWrapper: "",
    colorWrapper: "",
    colorLabel: "",
    colorValue: "",
    sizeWrapper: "",
    sizeLabel: "",
    sizeValue: "",
    stockStatus: "",
    // Quantity picker
    quantityPickerWrapper: "row-start-4 row-end-5 col-start-2 col-end-3 flex gap-3 items-center text-label-sm self-end",
    quantityPickerAdd: "w-6 h-6 flex justify-center items-center [&>svg]:fill-text-body [&>svg]:hover:fill-text-body [&>svg]:hover:cursor-pointer disabled:[&>svg]:fill-neutral-100 [&>svg]:w-2 [&>svg]:h-2",
    quantityPickerRemove: "w-6 h-6 flex justify-center items-center [&>svg]:disabled:fill-neutral-200 [&>svg]:w-2 [&>svg]:h-2 [&>svg]:fill-text-body [&>svg]:hover:fill-text-body [&>svg]:hover:cursor-pointer",
    quantityPickerValue: "w-auto flex justify-center h-8 w-6 items-center text-label-sm px-1 lg:px-0  placeholder:text-center shrink-0 opacity-100 placeholder:text-black bg-transparent text-center",
    // Bundle
    triggerBundle: "col-start-2 col-end-3 row-start-5 row-end-6",
    bundleItemWrapper: "",
    bundleItemName: "",
    bundleItemImage: "",
    bundleItemImageWrapper: "",
    bundleItemSizeRow: "",
    bundleItemSizeLabel: "",
    bundleItemSizeValue: "",
    // Display quantity
    quantityValue: "flex row-start-4 row-end-5 col-start-3 text-label-sm w-fit self-end bg-neutral-100 rounded-lg px-2 py-1 w-[20px]",
    // Remove button
    removeButton: "col-start-3 col-end-4 row-start-4 row-end-5 flex justify-end text-label-sm text-text-body self-end mb-2",
    // Badge
    badge: "row-start-2 row-end-4 col-start-3 col-end-4 self-end"
  },
  variants: {}
});
export {
  l as a,
  r as c
};
//# sourceMappingURL=blueprint-c4304960.mjs.map
